import { connect } from 'react-redux';
import Results from './results';
import { selectResult } from '../../reducers/test.reducers';

const mapStateToProps = state => ({
  isLoading: state.tests.isLoadingResults,
  results: state.tests.results
});

const mapDispatchToProps = dispatch => ({
  loadTest:(test) => dispatch(selectResult(test))
});

export default connect(mapStateToProps, mapDispatchToProps)(Results);



// WEBPACK FOOTER //
// ./src/app/main/results/results.container.js